import { useQuery } from '@/common/hooks/index';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

const useFilters = ({ type, data, sortFunc }) => {
  const history = useHistory();
  const query = useQuery();
  const initialFilters = {
    sortBy: query.get('sT') === type ? query.get('sB') || 'uid' : 'uid',
    sortOrder: query.get('sT') === type ? query.get('sO') || 'asc' : 'asc',
  };
  const [{ sortBy, sortOrder }, setFilters] = useState(initialFilters);
  const [sortedList, setSortedList] = useState(() =>
    sortFunc(initialFilters.sortBy, initialFilters.sortOrder, data)
  );

  useEffect(() => {
    setSortedList(sortFunc(sortBy, sortOrder, data));
  }, [data, sortBy, sortOrder, sortFunc]);

  const setSorting = (pSortBy, pSortOrder) => {
    let nextSortBy = sortBy;
    let nextSortOrder = sortOrder;
    if (pSortBy === sortBy) {
      nextSortOrder = pSortOrder || (nextSortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      nextSortBy = pSortBy;
      nextSortOrder = pSortOrder || 'asc';
    }
    const sortedItems = sortFunc(nextSortBy, nextSortOrder, data);

    history.replace(
      `${history.location.pathname}?sT=${type}&sB=${nextSortBy}&sO=${nextSortOrder}`
    );
    setFilters({ sortOrder: nextSortOrder, sortBy: nextSortBy });
    setSortedList(sortedItems);
  };

  useEffect(() => {
    if (query.get('sT') === type) {
      setSorting(query.get('sB') || sortBy, query.get('sO') || sortOrder);
    }
  }, [query, sortBy, sortOrder, type]);

  return {
    sortBy,
    sortOrder,
    setSorting,
    sortedList,
  };
};

export default useFilters;
